// extracted by mini-css-extract-plugin
export var closeButton = "_gb-2";
export var closeButtonIcon = "_gb-3";
export var lightboxContent = "_gb-1";
export var lightboxOverlay = "_gb-0";